import { ChapterResponse } from '@goldcast/api/content';
import { useEffect, useState } from 'react';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';
import { showErrorToast } from '@/libs/toast/toast';
import { useAppContext } from '@/context/AppContext/AppContext';
import useTranscriptPage from '@/Pages/TranscriptPage/useTranscriptPage';

export default function RenameChapter({ chapter, onClose }: { chapter: ChapterResponse; onClose: () => void }) {
  const [chapterName, setChapterName] = useState(chapter.title);
  const [isRenamingChapter, setIsRenamingChapter] = useState(false);
  const { logger } = useAppContext();
  const { updateChapter } = useTranscriptPage();

  useEffect(() => {
    setChapterName(chapter.title);
  }, [chapter.title]);

  const onConfirm = () => {
    setIsRenamingChapter(true);
    updateChapter(chapter.id, chapterName)
      .then(() => {
        setIsRenamingChapter(false);
        onClose();
      })
      .catch(err => {
        showErrorToast('Error while renaming chapter');
        logger.error('Error while renaming chapter', err);
      });
  };
  return (
    <ConfirmationDialog
      isOpen
      onClose={onClose}
      onConfirm={onConfirm}
      confirmLoading={isRenamingChapter}
      title="Rename Chapter"
      content={
        <input
          type="text"
          value={chapterName}
          onChange={e => setChapterName(e.target.value)}
          className="my-3 w-full rounded-md border border-gray-300 p-2 text-sm ring-slate-500 focus:ring-slate-500"
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onConfirm();
            }
          }}
        />
      }
      confirmLabel="Save"
      cancelLabel="Cancel"
    />
  );
}
